import produce, { Draft } from 'immer';
import { ActionType, getType } from 'typesafe-actions';
import * as actions from './actions';
import { initialServiceProductReportState, ServiceProductReportState } from './model';
import { initialProductState } from "../product/model";

const serviceProductReport = produce((draft: Draft<ServiceProductReportState>, action: ActionType<typeof actions>) => {
  switch (action.type) {
    case getType(actions.getServiceProductReportList.request): {
      draft.list.loading = true;
      return draft;
    }
    case getType(actions.getServiceProductReportList.success): {
      draft.list.loading = true;
      draft.list.response = action.payload;
      return draft;
    }
    case getType(actions.getServiceProductReportList.failure): {
      draft.list.loading = false;
      draft.list.errors = action.payload;
      return draft;
    }
    case getType(actions.getServiceProductReportDetails.request): {
      draft.details.loading = true;
      draft.details.response = undefined;
      draft.details.errors = undefined;
      return draft;
    }
    case getType(actions.getServiceProductReportDetails.success): {
      draft.details.loading = true;
      draft.details.response = action.payload;

      return draft;
    }
    case getType(actions.getServiceProductReportDetails.failure): {
      draft.details.loading = false;
      draft.details.errors = action.payload;
      return draft;
    }
    case getType(actions.clearData): {
      if (action.payload) {
        draft[action.payload] = {};
      } else {
        draft = initialProductState;
      }
      return draft;
    }
    default: {
      return draft;
    }
  }
}, initialServiceProductReportState);

export default serviceProductReport;
